import { useEffect } from "react";
import { ApiRequest, SchemaData, UseGetItemProps } from "./types";
import schemaJson from "../schema/SchemaJson.json";
import UISchemaJson from "../schema/UISchema.json";
import { GET_ITEM_QUERY, GetItemGql, responseGetItemKey } from "../queries/getItem";
import { removeNullValues } from "utils/removeNullValues";
const enter = `
`;
const useGetItem = ({ setState, setTemplate, queryParam }: UseGetItemProps<SchemaData>) => {
  const stringify = (content: string): string => {
    try {
      const obj = JSON.parse(content);
      if (!obj) return content;

      if (obj?.body?.query) {
        return JSON.stringify(
          {
            ...obj,
            body: {
              ...obj?.body,
              query: obj?.body?.query.replace(/\s+/g, " ").replace(/\r+/g, " ").trim(),
            },
          },
          null,
          2
        );
      }

      return JSON.stringify(obj, null, 2);
    } catch {
      return content;
    }
  };

  useEffect(() => {
    if (!!queryParam) {
      setState((props) => ({ ...props, messageError: undefined, criticalError: undefined }));
      ApiRequest<GetItemGql>({
        query: GET_ITEM_QUERY,
        variables: { id: queryParam },
      })
        .then((response) => {
          if (!response?.data?.data?.[responseGetItemKey]) {
            throw new Error("Não encontrado", {
              cause: { response: response?.data || response },
            });
          }

          const data = removeNullValues(response.data.data?.[responseGetItemKey]);

          console.log({ log: data });

          setState({
            data: {
              ...data,
              content: stringify(data?.content),
            },
          });

          setTemplate({
            schemaJson: schemaJson,
            UISchema: UISchemaJson,
          });
        })
        .catch((error) => {
          console.log({ error });

          setState((prev) => ({
            ...prev,
            criticalError: error?.response?.data?.errors?.[0] || error,
          }));
        });
    }
  }, [queryParam]);
};

export default useGetItem;
